import { getThemeAssetUrl } from './themeAssets';

const getBingoBallColor = (bingoballNumber, totalBalls, isBingoAnimation) => {
  const darkBlueBall = getThemeAssetUrl(
    'images/bingoBalls/bingoball-blue-600x600.png'
  );
  const greenBall = getThemeAssetUrl(
    'images/bingoBalls/bingoball-green-600x600.png'
  );
  const lightBlueBall = getThemeAssetUrl(
    'images/bingoBalls/bingoball-lightblue-600x600.png'
  );
  const orangeBall = getThemeAssetUrl(
    'images/bingoBalls/bingoball-orange-600x600.png'
  );
  const pinkBall = getThemeAssetUrl(
    'images/bingoBalls/bingoball-pink-600x600.png'
  );
  const cyanBall = getThemeAssetUrl(
    'images/bingoBalls/bingoball-cyan-600x600.png'
  );
  const yellowBall = getThemeAssetUrl(
    'images/bingoBalls/bingoball-yellow-600x600.png'
  );
  const redBall = getThemeAssetUrl(
    'images/bingoBalls/bingoball-red-600x600.png'
  );
  const purpleBall = getThemeAssetUrl(
    'images/bingoBalls/bingoball-purple-600x600.png'
  );

  let colorRanges;

  // Check if isBingoAnimation is true and return default color ranges
  if (isBingoAnimation) {
    colorRanges = [
      { range: [1, 15], path: pinkBall },
      { range: [16, 30], path: lightBlueBall },
      { range: [31, 45], path: darkBlueBall },
      { range: [46, 60], path: orangeBall },
      { range: [61, 75], path: greenBall },
    ];
  } else {
    switch (totalBalls) {
      case 90:
        colorRanges = [
          { range: [0, 9], path: pinkBall },
          { range: [10, 19], path: lightBlueBall },
          { range: [20, 29], path: darkBlueBall },
          { range: [30, 39], path: orangeBall },
          { range: [40, 49], path: greenBall },
          { range: [50, 59], path: redBall },
          { range: [60, 69], path: cyanBall },
          { range: [70, 79], path: yellowBall },
          { range: [80, 200], path: purpleBall },
        ];
        break;
      case 80:
        colorRanges = [
          { range: [0, 20], path: pinkBall },
          { range: [21, 40], path: greenBall },
          { range: [41, 60], path: darkBlueBall },
          { range: [61, 200], path: orangeBall },
        ];
        break;
      case 60:
        colorRanges = [
          { range: [0, 15], path: pinkBall },
          { range: [16, 30], path: greenBall },
          { range: [31, 45], path: darkBlueBall },
          { range: [46, 200], path: orangeBall },
        ];
        break;
      case 40:
        colorRanges = [
          { range: [0, 10], path: pinkBall },
          { range: [11, 20], path: greenBall },
          { range: [21, 30], path: darkBlueBall },
          { range: [31, 200], path: orangeBall },
        ];
        break;
      case 30:
        colorRanges = [
          { range: [0, 10], path: pinkBall },
          { range: [11, 20], path: greenBall },
          { range: [21, 200], path: darkBlueBall },
        ];
        break;
      case 75:
      default:
        colorRanges = [
          { range: [0, 15], path: pinkBall },
          { range: [16, 30], path: lightBlueBall },
          { range: [31, 45], path: darkBlueBall },
          { range: [46, 60], path: orangeBall },
          { range: [61, 200], path: greenBall },
        ];
        break;
    }
  }

  const colorRange = colorRanges.find(
    ({ range }) => bingoballNumber >= range[0] && bingoballNumber <= range[1]
  );

  if (colorRange) {
    return {
      path: colorRange.path,
    };
  }

  return null;
};

export default getBingoBallColor;
